export const LogInState = {
  success: "success",
  idle: "idle",
  passwordNotMatchError: "passwordNotMatchError",
  userNotFoundError: "userNotFoundError",
};

export const SignUpState = {
  success: "success",
  idle: "idle",
  weakPassword: "weakPassword",
  badEmail: "badEmail",
};
